import {useEffect,useState,useMemo} from "react";
import {TextField} from '@mui/material';
import {NumericFormat} from "react-number-format";
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
import {getCurrencyLocaleFromLang} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldCurrency=({row,fieldName,application,recordRules,readOnly,setFieldValue,setFieldChanged})=>{
    const fieldProp=row?.[fieldName];
    const fieldValue=fieldProp?.value;
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    // fieldValue can legitimately be 0 (e.g. a free product) - `||` treats
    // that as falsy and would blank the field out, so this uses `??` instead.
    const [inputValue,setInputValue]=useState(fieldValue??"");
    const [isFieldChanged,setIsFieldChanged]=useState(false);
    const currencyCodeField=row[fieldName]?.currency_code_field;
    const currencyCode=currencyCodeField&&row[currencyCodeField]?.value?row[currencyCodeField]?.value:"USD";
    const userLocale=getCurrencyLocaleFromLang(application.globalData?.user?.lang);

    useEffect(()=>{
      setIsFieldChanged(false);
      setInputValue(fieldValue??"");
    },[fieldValue]);

    const numberFormatter=useMemo(()=> new Intl.NumberFormat(userLocale),[userLocale]);
    const currencyFormatter=useMemo(()=> new Intl.NumberFormat(userLocale, {
      style:"currency",
      currency:currencyCode
    }),[userLocale, currencyCode]);
    const thousandSeparator=useMemo(()=>{
      return numberFormatter.format(11111).charAt(2);
    },[numberFormatter]);
    const decimalSeparator=useMemo(()=>{
      return numberFormatter.format(1.1).charAt(1);
    },[numberFormatter]);
    const currencyPrefix=useMemo(()=>{
      return currencyFormatter.formatToParts(0).find(p=>p.type==="currency")?.value||"";
    },[currencyFormatter]);

    return (
      <NumericFormat
        value={inputValue}
        decimalScale={2}
        fixedDecimalScale
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        prefix={currencyPrefix}
        customInput={TextField}
        onValueChange={(values)=>{
          if(!isFieldChanged){setIsFieldChanged(true)}
          setInputValue(values.floatValue??"");
          setFieldChanged();
        }}
        onBlur={(e)=>{if(isFieldChanged){setFieldValue(fieldName,inputValue)};}}
        InputProps={{readOnly:readOnlyEvaluated}}
        sx={{div:{backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:""}}}
        fullWidth
        margin="normal"
        id={fieldName}
        name={fieldName}
        required={fieldProp?.required?fieldProp?.required:false}
        error={fieldProp?.validation_error?fieldProp?.validation_error:false}
        helperText={fieldProp?.validation_error_message?fieldProp?.validation_error_message:''}
        label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
        variant="outlined"
        size="small"
      />
    );
}

export default FieldCurrency;
